import {getJCP} from "./jcp";
import {iJcp, iLic} from "../index";

let globalMsg;

const JCP = {
    setup: {
        version: '10.0.4021', // ææ°çæ¬ 10.0.4092
        versionTime: '2018.4.16', // åçæ¥æ
        longVersion: '10',
        smallVersion: '0.4021',
        noSetupHandle: function (message) {
            globalMsg = message || 'æ°è¡¨äºæå°ï¼JCPï¼æªå®è£ææªå¼å¯ï¼è¯·ç¡®è®¤ï¼';
        }
    },
    STATES: {
        PRINTER_PRINTING: 0x00000400, // æ­£å¨æå°...
        PRINTER_PAUSED: 0x00000001, // æå°æåä¸­...
        PRINTER_BUSY: 0x00000200, // æå°æºç¹å¿
        PRINTER_WAITING: 0x00002000, // æå°ç­å¾ä¸­...
        PRINTER_ERROR: 0x00000002, // æå°åºé
        PRINTER_PAPER_JAM: 0x00000008, // æå°æºå¡çº¸
        PRINTER_PAPER_OUT: 0x00000010, // ç¼ºçº¸
        PRINTER_PAPER_PROBLEM: 0x00000040, // æå°çº¸åºç°é®é¢
        PRINTER_OUTPUT_BIN_FULL: 0x00000800, // æå°è¾åºå·²æ»¡
        PRINTER_NOT_AVAILABLE: 0x00001000, // æå°æºä¸å¯ç¨
        PRINTER_TONER_LOW: 0x00020000, // æå°æºå¢¨ç²ä¸è¶³
        PRINTER_NO_TONER: 0x00040000, // æå°æºæ²¡æå¢¨ç²
        PRINTER_OFFLINE: 0x00000080, // æ æ³è¿æ¥æå°æº
        PRINTER_OUT_OF_MEMORY: 0x00200000, // æå°åå­æº¢åº
        PRINTER_DOOR_OPEN: 0x00400000, // æå°æºçé¨æ¯å¼ççï¼è¯·å³é­
    }
};

let LIC: iLic;

/**
 * è®¾ç½®å¨å±å¼å¸¸å¤çåè®¤è¯ä¿¡æ¯
 * @param lic è®¤è¯ä¿¡æ¯
 */
export function jcpSetup(lic: iLic) {
    LIC = lic;
}

export async function getJCPTools(): Promise<iJcp> {

    if (!LIC) {
        throw 'æªè®¾ç½®LICè®¤è¯ä¿¡æ¯ï¼è¯·éè¿ jcpSetup è®¾ç½®';
    }

    const jcp = getJCP(null, JCP, LIC);

    // 1 è·åçæ¬å·
    let version: string = await promiseWrap(jcp, 'getVersion');
    version = String(version);
    var idx = version.indexOf('.');
    var longVersion = version.substring(0, idx);
    var smallVersion = version.substring(idx + 1);

    if (longVersion !== JCP.setup.longVersion || smallVersion < JCP.setup.smallVersion) {
        const msg = 'æ°è¡¨äºæå°ï¼JCPï¼çæ¬å·ä¸å¹éï¼è¯·éæ°å®è£æå°æ§ä»¶ã';
        alert(msg);
        throw msg;
    }

    // 2 è·åæææå°æº
    const printers: string[] = await promiseWrap(jcp, 'getPrinters');

    if (!printers || !printers.length) {
        throw 'æªåå¾ç³»ç»å·²ç»å®è£çæå°æºï¼è¯·å®è£æå°æºé©±å¨åéè¯éè¯ã';
    }

    // 3 è·åé»è®¤æå°æº
    const defaultPrinter = await promiseWrap(jcp, 'getDefaultPrinter');
    if (/PDF|XPS|Fax|OneNote|Office|èææå°/i.test(defaultPrinter)) {
        throw 'é»è®¤æå°æºä¸åè®¸è®¾ç½®ä¸º(PDFï¼XPSï¼Faxï¼OneNoteï¼Office)ç­èææå°æº,è¯·ä¿®æ¹é»è®¤æå°æºåéè¯ã';
    }

    // 4 è·åè¯¥æå°æºç¶æ
    const status = await promiseWrap(jcp, 'getPrinterStatus', defaultPrinter, true);

    try {
        if (status & JCP.STATES.PRINTER_BUSY) {
            throw "æå°æºç¹å¿";
        }

        if (status & JCP.STATES.PRINTER_PAPER_JAM) {
            throw "æå°æºå¡çº¸";
        }

        if (status & JCP.STATES.PRINTER_PAPER_OUT) {
            throw "ç¼ºçº¸";
        }

        if (status & JCP.STATES.PRINTER_PAPER_PROBLEM) {
            throw "æå°çº¸åºç°é®é¢";
        }

        if (status & JCP.STATES.PRINTER_OUTPUT_BIN_FULL) {
            throw "æå°è¾åºå·²æ»¡";
        }

        if (status & JCP.STATES.PRINTER_NOT_AVAILABLE) {
            throw "æå°æºä¸å¯ç¨";
        }

        if (status & JCP.STATES.PRINTER_TONER_LOW) {
            throw "æå°æºå¢¨ç²ä¸è¶³";
        }

        if (status & JCP.STATES.PRINTER_NO_TONER) {
            throw "æå°æºæ²¡æå¢¨ç²";
        }

        if (status & JCP.STATES.PRINTER_OUT_OF_MEMORY) {
            throw "æå°åå­æº¢åº";
        }

        if (status & JCP.STATES.PRINTER_OFFLINE) {
            throw "æ æ³è¿æ¥æå°æº";
        }

        if (status & JCP.STATES.PRINTER_DOOR_OPEN) {
            throw "æå°æºçé¨æ¯å¼ççï¼è¯·å³é­";
        }
    } catch (e) {
        throw e + '\n è¯·æé¤æå°æºé®é¢åå·æ°é¡µé¢éè¯æ­¤æä½ã';
    }

    wrapFn(jcp);

    return jcp;
}

function promiseWrap(jcp, method, ...args): Promise<any> {
    return new Promise(function (resolve, reject) {
        let timer;
        args.push(function () {
            resolve();
            clearTimeout(timer);
        });
        jcp[method].apply(jcp, args);
        timer = setTimeout(function () {
            globalMsg && reject(globalMsg);
        }, 500);
    });
}

function wrapFn(jcp) {
    const print = jcp.print;
    jcp.print = function (myDoc, preview) {
        print(docFix(myDoc), preview);
        return moreTime(3000);
    };

    const printDocument = jcp.printDocument;
    jcp.printDocument = function (path, myDoc) {
        printDocument(path, docFix(myDoc));
        return moreTime(3000);
    };

    wrapFn('getVersion');
    wrapFn('setDefaultPrinter');
    wrapFn('getDefaultPrinter');
    wrapFn('getPrinters');

    function wrapFn(method) {
        const fn = jcp[method];
        jcp[method] = function (...args) {
            return new Promise(function (resolve) {
                args.push(resolve);
                fn(...args);
            });
        };
    }

    function docFix(doc) {
        doc.key = LIC.key;
        doc.copyrights = LIC.copyrights;
        delete doc.done;
        return doc;
    }
}

function moreTime(time = 1000) {
    return new Promise(function (resolve) {
        setTimeout(resolve, time);
    });
}
